import React, { ReactElement } from 'react'
import * as style from 'src/component-flyout/AssignAccountOwnerFlyout/components/AssignAccountOwnerCardsTable.style'
import MaskedCardNumber from 'src/components/MaskedCardNumber/MaskedCardNumber'
import { useTranslate } from 'src/localization/Trns'
import { CardFeedCard } from 'src/queries/cardFeeds/cardFeeds.models'

export interface AssignAccountOwnerCardsTableProps {
  cards: CardFeedCard[]
}

const AssignAccountOwnerCardsTable: React.FC<
  AssignAccountOwnerCardsTableProps
> = ({ cards }) => {
  const translate = useTranslate()

  return (
    <table
      css={style.table}
      data-testid="assign-account-owner-cards-table"
      aria-label={translate('Cards being assigned')}
    >
      <thead>
        <tr>
          <th scope="col">{translate('Card Display Name')}</th>
          <th scope="col">{translate('Card Number')}</th>
        </tr>
      </thead>
      <tbody>
        {cards.map((card) => (
          <CardRow key={card.id} card={card} />
        ))}
      </tbody>
    </table>
  )
}

interface CardRowProps {
  card: CardFeedCard
}

const CardRow: React.FC<CardRowProps> = ({ card }): ReactElement => (
  <tr data-testid="assign-account-owner-card-row">
    <td css={style.cardNameCell}>{card.cardName}</td>
    <td css={style.cardNumberCell}>
      <MaskedCardNumber lastFour={card.lastFour} />
    </td>
  </tr>
)

export default AssignAccountOwnerCardsTable
